import React, { useState, useEffect } from 'react';
import { useApi } from '../../../hooks/useApi';
import logger from "../../../utils/logger";
import { fmtDate } from '../../../utils/ruDates';
import EntityCell from '../EntityCell';
function AdminApiTokens() {
  const {
    request
  } = useApi();
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    loadTokens();
  }, []);
  const loadTokens = async () => {
    setLoading(true);
    try {
      const data = await request('/api/v1/admin/api-tokens');
      setTokens(data || []);
    } catch (error) {
      logger.error('Failed to load tokens', error);
    } finally {
      setLoading(false);
    }
  };
  return <div className="admin-page">
            <div style={{
      marginBottom: '30px'
    }}>
                <h1>API-токены (интеграции)</h1>
                <p style={{
        color: '#666'
      }}>Токены, выпущенные компаниями для программного доступа</p>
            </div>

            <div style={{
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
      overflow: 'hidden'
    }}>
                <table style={{
        width: '100%',
        borderCollapse: 'collapse'
      }}>
                    <thead style={{
          background: '#f8f9fa',
          borderBottom: '2px solid #eee'
        }}>
                        <tr>
                            <th style={{
              padding: '15px',
              textAlign: 'left'
            }}>Название / Префикс</th>
                            <th style={{
              padding: '15px',
              textAlign: 'left'
            }}>Компания</th>
                            <th style={{
              padding: '15px',
              textAlign: 'center'
            }}>Лимит (мес)</th>
                            <th style={{
              padding: '15px',
              textAlign: 'center'
            }}>Использовано</th>
                            <th style={{
              padding: '15px',
              textAlign: 'center'
            }}>Статус</th>
                            <th style={{
              padding: '15px',
              textAlign: 'right'
            }}>Создан</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && <tr><td colSpan="6" style={{
              padding: '40px',
              textAlign: 'center'
            }}>Загрузка...</td></tr>}
                        {!loading && tokens.length === 0 && <tr><td colSpan="6" style={{
              padding: '40px',
              textAlign: 'center'
            }}>Токенов не найдено</td></tr>}
                        {tokens.map(token => <tr key={token.id} style={{
            borderBottom: '1px solid #f5f5f5'
          }}>
                                <td style={{
              padding: '15px'
            }}>
                                    <EntityCell
                                        name={token.name}
                                        owner={token.owner_email}
                                        note={`${token.company_name} · ${token.token_prefix}...`}
                                        id={token.id}
                                    />
                                </td>
                                <td style={{
              padding: '15px'
            }}>{token.company_name}</td>
                                <td style={{
              padding: '15px',
              textAlign: 'center'
            }}>{token.monthly_limit.toLocaleString()}</td>
                                <td style={{
              padding: '15px',
              textAlign: 'center'
            }}>
                                    <div style={{
                fontWeight: 'bold',
                color: token.used_this_month > token.monthly_limit ? '#e74c3c' : '#2ecc71'
              }}>
                                        {token.used_this_month.toLocaleString()}
                                    </div>
                                </td>
                                <td style={{
              padding: '15px',
              textAlign: 'center'
            }}>
                                    {token.revoked_at ? <span style={{
                color: '#e74c3c',
                fontSize: '12px'
              }}>Отозван {fmtDate(token.revoked_at)}</span> : <span style={{
                color: '#27ae60',
                fontSize: '12px'
              }}>Активен</span>}
                                </td>
                                <td style={{
              padding: '15px',
              textAlign: 'right',
              color: '#666',
              fontSize: '13px'
            }}>
                                    {fmtDate(token.created_at)}
                                </td>
                            </tr>)}
                    </tbody>
                </table>
            </div>
        </div>;
}
export default AdminApiTokens;
